import React from 'react';
import ChatInterface from './ChatInterface';

function App() {
  return (
    <div className="App">
      <ChatInterface />
    </div>
  );
}

export default App;